import AnalyticsController from '../analytics_controller'

export default class extends AnalyticsController {

  connect() {
    if (this.shouldDisplayChart()) {
      this.getChart(this.setParams())
    }
    this.fireNativeEvent()
  }
}
